import { create } from 'zustand';

type State<T extends unknown = unknown> = {
  modal: string;
  isOpen: boolean;
  data: Record<string, T>;
};

type Actions = {
  open: (modal: string) => void;
  close: () => void;
};

const useModalTemplateStore = create<State & Actions>((set) => ({
  modal: '',
  isOpen: false,
  data: {} as Record<string, unknown>,
  open: (modal) => {
    set({ isOpen: true, modal });
  },
  close: () => {
    set({ isOpen: false, modal: '' });
  },
}));

export default useModalTemplateStore;
